const { atom } = require("recoil");

export const loggedInUserState = atom({
  key: "loggedInUserState",
  default: {}
});

export const CompanyState = atom({
  key: "CompanyState",
  default: {}
});

export const metaDataState = atom({
  key: "MetaDataState",
  default: {}
});

export const permissionState = atom({
  key: "PermissionState",
  default: {}
});

export const targetCompletionAnimationState = atom({
  key: "TargetCompletionAnimationState",
  default: false
});

export const userDetailsState = atom({
  key: "userDetailsState",
  default: {}
});